import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';
import { ReactComponent as Meta } from 'assets/meta-business-partner.svg';

export const MetaBadge = ({
  className,
  style: styleFromProps,
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <figure
      style={{ margin: 0, height: 44, ...style }}
      className={classNames(className)}
      onClick={onClick}
    >
      <Meta />
    </figure>
  );
};
